import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import API from "../../../../services/api";

import Card from "../../common/Card/Card";
import Loader from "../../common/Loader/Loader";
import EmptyState from "../../common/EmptyState/EmptyState";
import Button from "../../common/Button/Button";

import "./RecentOrders.css";

function RecentOrders({ dashboard = {} }) {

    const navigate = useNavigate();

    const [orders, setOrders] = useState(
        dashboard.recentOrders || []
    );

    const [loading, setLoading] = useState(
        !dashboard.recentOrders
    );

    useEffect(() => {

        if (
            dashboard.recentOrders &&
            dashboard.recentOrders.length > 0
        ) {

            setOrders(dashboard.recentOrders);

            setLoading(false);

            return;

        }

        let mounted = true;

        const loadOrders = async () => {

            try {

                const res = await API.get(
                    "/admin/recent-orders"
                );

                if (mounted) {

                    setOrders(
                        res.data.orders || []
                    );

                }

            }

            catch (error) {

                console.error(
                    "Failed to load recent orders",
                    error
                );

            }

            finally {

                if (mounted) {

                    setLoading(false);

                }

            }

        };

        loadOrders();

        return () => {

            mounted = false;

        };

    }, [dashboard]);

    const getStatusClass = (status) => {

        switch (status?.toLowerCase()) {

            case "delivered":
                return "status delivered";

            case "preparing":
                return "status preparing";

            case "cancelled":
                return "status cancelled";

            case "pending":
                return "status pending";

            default:
                return "status";

        }

    };

    if (loading) {

        return (

            <Card title="Recent Orders">

                <Loader />

            </Card>

        );

    }

    if (!orders.length) {

        return (

            <Card title="Recent Orders">

                <EmptyState
                    title="No Orders"
                    subtitle="No recent orders found."
                />

            </Card>

        );

    }

    return (

        <Card title="Recent Orders">

            <div className="recent-orders-list">

                {

                    orders.map((order) => (

                        <div
                            key={order._id}
                            className="recent-order"
                        >

                            <div className="order-left">

                                <div className="order-avatar">

                                    {(
                                        order.customerId?.name ||
                                        "C"
                                    )
                                        .charAt(0)
                                        .toUpperCase()}

                                </div>

                                <div className="order-info">

                                    <h4>

                                        {
                                            order.orderNumber ||
                                            order._id.slice(-6)
                                        }

                                    </h4>

                                    <p>

                                        {
                                            order.customerId?.name ||
                                            "Customer"
                                        }

                                    </p>

                                    <small>

                                        ₹
                                        {Number(
                                            order.grandTotal || 0
                                        ).toLocaleString("en-IN")}

                                    </small>

                                </div>

                            </div>

                            <div className="order-right">

                                <span
                                    className={getStatusClass(order.status)}
                                >

                                    {order.status}

                                </span>

                                <Button
                                    size="small"
                                    variant="primary"
                                    onClick={() =>
                                        navigate(
                                            `/admin/orders/${order._id}`
                                        )
                                    }
                                >

                                    View

                                </Button>

                            </div>

                        </div>

                    ))

                }

            </div>

        </Card>

    );

}

export default RecentOrders;